/**
 * file-url.ts — render-boundary file URL helper for the agent console.
 *
 * Mirrors apps/chat-v1 lib/files.ts `toBrowserFileUrl`: in local/dockerized dev the demo uploader
 * bakes a docker-internal host (`localstack:4566`) into file_url that the BROWSER can't resolve, so
 * an image/video <img|video src> silently breaks (empty bubble). The customer widget already rewrites
 * it at its render boundary; the console did not — this restores parity. Prod is untouched (unset env
 * → identity, so CloudFront/S3 URLs pass through).
 */

/** Dev-only mapping `from=to` (e.g. `localstack:4566=localhost:4566`); unset in prod. */
const getFileHostRewrite = (): string | undefined => process.env.REACT_APP_FILE_HOST_REWRITE

/**
 * Map a stored file URL to one the browser can load. Use ONLY at the render boundary (img/video/
 * download) — the canonical host stays in the persisted chunk + the URL the agent/AI fetches inside
 * docker. Unset `REACT_APP_FILE_HOST_REWRITE` → identity (prod URLs never touched).
 */
export const toBrowserFileUrl = (url: string): string => {
  const rewrite = getFileHostRewrite()
  if (!rewrite || !url) return url
  const [from, to] = rewrite.split('=')
  return from && to ? url.replace(from, to) : url
}
